export default __webpack_public_path__ + "static/media/pets.4867f376.jpg";